import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import Swiper from 'swiper';
// import 'swiper/css';
import Lenis from 'lenis'
import 'lenis/dist/lenis.css'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  // お問い合わせ用バリデーション
  if (document.body.classList.contains('contact')) {
    topValidation();
  }

  document.querySelectorAll('.js-outline-outside').forEach(el => {
    // 既存HTMLには手を入れず、表示文字を data-outline に複製
    el.setAttribute('data-outline', (el.textContent || '').replace(/\s+/g, ' ').trim());
  });

  const gnav = document.querySelector('.gnav');
  const gnavHeight = gnav ? gnav.offsetHeight : 0;

  ScrollTrigger.matchMedia({
    // PCのみ(例:768px以上)
    "(min-width: 768px)": () => {
      ScrollTrigger.create({
        start: gnavHeight,
        end: "max",
        onEnter: () => gnav?.classList.add("is-fixed"),
        onLeaveBack: () => gnav?.classList.remove("is-fixed"),
      });
    }
  });

  const updateGnavHeight = () => {
    if (!gnav) return;
    const h = gnav.offsetHeight;
    document.documentElement.style.setProperty('--gnav-height', `${h}px`);
  };

  // 初回
  window.addEventListener('load', updateGnavHeight);

  // ResizeObserver で .gnav の高さを監視
  if (gnav) {
    const ro = new ResizeObserver(() => {
      updateGnavHeight();
    });
    ro.observe(gnav);
  }

  // btn-trigger
  const btnTrigger = document.querySelector('.btn-toggle');
  const navGlobal = document.querySelector('.gnav_list_wrapper');

  if (btnTrigger && navGlobal) {

    function toggleNav() {
      btnTrigger.classList.toggle('is-open');
      navGlobal.classList.toggle('is-open');
    }

    btnTrigger.addEventListener('click', toggleNav);
  }


  // サイドメニューのピン留め設定
  const serviceSidebar = document.querySelector('.cmn_sidebar_wrapper');
  const footer = document.querySelector('footer');

  if(serviceSidebar && footer) {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {
      gsap.to(serviceSidebar, {
        scrollTrigger: {
          trigger: serviceSidebar,
          start: () => `top ${document.documentElement.style.getPropertyValue('--gnav-height')}`,
          scrub: 1,
          pin: serviceSidebar,
          endTrigger: footer,
          end: "top bottom+=150px",
          pinSpacing: false,
        }
      });
    });
  }

  // スライダー初期化関数
  const initSwiper = (selector, config) => {
    const container = document.querySelector(selector);
    if (!container) return null;

    const slides = container.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;

    // 現在の画面幅を判定
    const isMobile = window.innerWidth < 768;
    
    // スライダーを停止すべきか判定
    const shouldDisable = isMobile ? slideCount <= 1 : slideCount <= 2;

    if (shouldDisable) {
      container.classList.add('is-disabled');
      // スライダーを無効化
      return null;
    }

    container.classList.remove('is-disabled');

    // Swiperを初期化
    return new Swiper(selector, config);
  };

  const commonSwiperConfig = {
    slidesPerView: 1.5,
    spaceBetween: 20,
    loop: true,
    loopAdditionalSlides: 5,
    grabCursor: true,
    freeMode: true,
    centeredSlides: true,
    speed: 500,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1199: {
        slidesPerView: 4,
        spaceBetween: 75,
      },
    },
  };

  let recommendSwiper = null;
  let blogSwiper = null;

  const initAllSwipers = () => {
    // 既存のSwiperインスタンスを破棄
    if (recommendSwiper) {
      recommendSwiper.destroy(true, true);
      recommendSwiper = null;
    }
    if (blogSwiper) {
      blogSwiper.destroy(true, true);
      blogSwiper = null;
    }

    // 再初期化
    recommendSwiper = initSwiper('.index_recommend_slider', commonSwiperConfig);
    blogSwiper = initSwiper('.index_blog_list_slider', commonSwiperConfig);
  };

  // 初回実行
  initAllSwipers();

  // リサイズ時に再判定
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      initAllSwipers();
    }, 250);
  });

  document.querySelectorAll('.service_slider_wrapper').forEach((gallery) => {
    const slideElements = gallery.querySelectorAll('.swiper-slide');
    const slideCount = slideElements.length;
    
    new Swiper(gallery, {
      loop: true,
      loopedSlides: slideCount,
      slidesPerView: 2,
      spaceBetween: 10,
      speed: 8000, // スライドのスピードを滑らかに
      centeredSlides: false,
      freeMode: true, // スライドの停止を防ぐためにfreeModeを有効化
      allowTouchMove: false, // スワイプ無効

      autoplay: {
        delay: 0, // 遅延なしで自動再生
        disableOnInteraction: false,
      },

      breakpoints: {
        768: {
          slidesPerView: 4.2,
          spaceBetween: 30,
        },
      },
    }); 
  });

  gsap.utils.toArray('.right-to-left').forEach((el) => {
    const width = el.offsetWidth;
    const parentWidth = el.parentElement.offsetWidth;

    gsap.fromTo(
      el,
      { x: 0 },
      {
        x: -(width / 2),       
        ease: "none",
        scrollTrigger: {
          trigger: el.parentElement,   // .marquee-trigger をトリガーにするのが安定
          start: "top bottom",         // 下から入ってきた時
          end: "bottom top",           // 上に抜ける時
          scrub: 3,                    // スクロール量に比例
        }
      }
    );
  });

  gsap.to(".index_service_bg img", {
    y: "-30%",
    ease: "none",
    scrollTrigger: {
      trigger: ".index_service_bg_wrapper",
      start: "top bottom",
      end: "bottom top",
      scrub: 2,
    }
  });

  setUpAccordion();


  // すべての .recruit_requirements_unit を取得
  const units = document.querySelectorAll('.recruit_requirements_unit');

  units.forEach(unit => {
    // その unit の中に .cmn_list_01 があるか探す
    const hasList = unit.querySelector('.cmn_list_01');

    // もし無ければ (.cmn_list_01 が null なら)、その unit を削除する
    if (!hasList) {
      unit.remove();
    }
  });
});


/**
 * ライブラリ(GSAP)を使ってアコーディオンのアニメーションを制御します
 */
const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-details");
  const IS_OPENED_CLASS = "is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".js-summary");
    const content = element.querySelector(".js-details-content");
    const parentLi = element.closest('li');

    const toggleAccordion = (event) => {
      // デフォルトの挙動を無効化
      event.preventDefault();

      if (element.classList.contains(IS_OPENED_CLASS)) {
        element.classList.toggle(IS_OPENED_CLASS);

        // アニメーション実行
        closingAnim(content, element).restart();
      } else {
        element.classList.toggle(IS_OPENED_CLASS);
        element.setAttribute("open", "true");
        openingAnim(content).restart();
      }
    };

    // summary.addEventListener("click", toggleAccordion);
    
    if (parentLi) {
      parentLi.addEventListener("click", toggleAccordion);
    }
  });
}

/**
 * アコーディオンを閉じる時のアニメーション
 */
const closingAnim = (content, element) => gsap.to(content, {
  height: 0,
  opacity: 0,
  duration: 0.4,
  ease: "power3.out",
  overwrite: true,
  onComplete: () => {
    element.removeAttribute("open");
  },
});

/**
 * アコーディオンを開く時のアニメーション
 */
const openingAnim = (content) => gsap.fromTo(
content,
{
  height: 0,
  opacity: 0,
},
{
  height: "auto",
  opacity: 1,
  duration: 0.4,
  ease: "power3.out",
  overwrite: true,
});


const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);